import React from 'react';
import './table.sass';

export const TableRow = ({ header = false, children, onClick, classNames, id, key }) => {
  return (
    <div key={key} className={`${classNames} vv-table-row ${header ? 'vv-table-row__header' : ''}`} data-testid={id}>
      {React.Children.map(children, (child, i) => {
        return (
          <div
            className='vv-table-row-row__cell'
            key={i}
            style={{
              flex: `${children[i].props['data-flex']} 0 0`,
              minWidth: children[i].props['data-width'],
            }}>
            {React.cloneElement(child, {
              onClick: onClick,
            })}
          </div>
        );
      })}
    </div>
  );
};
